import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { encodeQueryValue } from "./queryString";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/salonaccess/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    if (["gender"].includes(value) && values[value] && typeof values[value] === "object") {
      formData.append(value, values[value].value);
    } else {
      formData.append(value, values[value]);
    }
  }
  const action = "afterlogin/salonaccess/update/" + values.id;
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : '';
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      return sortArray[index] = `sort[${key}]=${sort[key]}`;
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if(values){
    if(values.id){
      pagination = false;
    }
    if(values.option){
      pagination = false;
    }
    if(values.pagination){
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/salonaccess/view?page=${page}&${sortstring}` : `afterlogin/salonaccess/view?${sortstring}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, 
    option: values && values.option ? values.option : ''
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/salonaccess/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const suggetionlist = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  let q = values && values.q ? values.q : "";
  const encodedQ = encodeQueryValue(q);
  const action = page ? `afterlogin/salonaccess/view?page=${page}&q=${encodedQ}` : `afterlogin/salonaccess/view?q=${encodedQ}`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: true, //true or false
    id: values && values.id ? values.id : "",
    apicall:'suggetion'
  };
  return axios.post(next_page_url ? `${next_page_url}&q=${encodedQ}` : API_URL + action, data, { headers: authHeader() });
};

const salonaccessApiController = {
  create,
  update,
  view,
  deleted,
  suggetionlist,
};
export default salonaccessApiController;
